export default __webpack_public_path__ + "static/advocacy-mobile-a12314525c559f60d9002180e4f10943.png";